"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _CourseLoader = _interopRequireDefault(require("./CourseLoader"));

var CourseHelper = /*#__PURE__*/function () {
  function CourseHelper() {
    (0, _classCallCheck2["default"])(this, CourseHelper);
  }

  (0, _createClass2["default"])(CourseHelper, null, [{
    key: "isIdInCourse",
    value: function isIdInCourse(course, id) {
      return CourseHelper.getElementWithIdInCourse() !== null;
    }
  }, {
    key: "getElementWithIdInCourse",
    value: function getElementWithIdInCourse(course, id) {
      if (!course || !id) {
        return null;
      }

      if (course.id === id) {
        return course;
      }

      if (course.pages) {
        var foundPage = course.pages.find(function (page) {
          return page.id === id;
        });

        if (foundPage) {
          return foundPage;
        }
      }

      if (course.chapters) {
        return course.chapters.find(function (chapter) {
          return CourseHelper.getElementWithIdInCourse(chapter, id);
        });
      }

      return null;
    }
  }, {
    key: "_getPathToElementInCourse",
    value: function _getPathToElementInCourse(course, id, pathSoFar) {
      if (!course || !id) {
        return null;
      }

      if (course.id === id) {
        return pathSoFar;
      }

      if (course.pages && course.pages.length > 0 && course.pages.some(function (page) {
        return page.id === id;
      })) {
        return pathSoFar.concat(course.id);
      }

      if (course.chapters && course.chapters.length > 0) {
        var foundPath = null;
        course.chapters.some(function (chapter) {
          var path = CourseHelper._getPathToElementInCourse(chapter, id, pathSoFar.concat(course.id));

          if (path) {
            foundPath = path;
            return true;
          }

          return false;
        });

        if (foundPath) {
          return foundPath;
        }
      }

      return null;
    }
    /**
     * Returns the path to an element in given course. The given `id` is contained in the path.
     */

  }, {
    key: "getPathToElementInCourse",
    value: function getPathToElementInCourse(course, id) {
      var path = CourseHelper._getPathToElementInCourse(course, id, []).concat(id);

      return path || [];
    }
  }, {
    key: "getElementByPathInCourse",
    value: function getElementByPathInCourse(course, path) {
      if (!course) {
        return null;
      }

      if (path.length === 1 && course.id === path[0]) {
        return course;
      }

      if (path.length > 0 && course.chapters) {
        var nextChapter = course.chapters.find(function (chapter) {
          return chapter.id === path[1];
        });
        return CourseHelper.getElementByPathInCourse(nextChapter, path.slice(1));
      }

      return null;
    }
    /**
     * Returns the first parent course of the given course having the given type.
     * Returns the given course if that course already has the type looked for.
     */

  }, {
    key: "findParentCourseWithType",
    value: function () {
      var _findParentCourseWithType = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(course, type) {
        var parentCourse;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!course || !type || !course.parent)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", null);

              case 2:
                if (!(course.type === type)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", course);

              case 4:
                _context.next = 6;
                return _CourseLoader["default"].getCourse(course.parent);

              case 6:
                parentCourse = _context.sent;
                return _context.abrupt("return", CourseHelper.findParentCourseWithType(parentCourse, type));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function findParentCourseWithType(_x, _x2) {
        return _findParentCourseWithType.apply(this, arguments);
      }

      return findParentCourseWithType;
    }()
  }]);
  return CourseHelper;
}();

exports["default"] = CourseHelper;